import { focusedConnect } from '../utils/editor';

export const EDITOR_NAME = 'campaignEditor';
export const connectEditor = focusedConnect.bind(null, EDITOR_NAME);
